import api from './axios';

export const getAssignmentGroups = async (params = {}) => {
  const response = await api.get('/assignment-groups', { params });
  return response.data;
};

export const createAssignmentGroup = async (payload) => {
  const response = await api.post('/assignment-groups', payload);
  return response.data;
};

export const updateAssignmentGroup = async (groupId, payload) => {
  const response = await api.put(`/assignment-groups/${groupId}`, payload);
  return response.data;
};

export const deleteAssignmentGroup = async (groupId) => {
  const response = await api.delete(`/assignment-groups/${groupId}`);
  return response.data;
};

export const getAssignmentGroupMembers = async (groupId) => {
  const response = await api.get(`/assignment-groups/${groupId}/members`);
  return response.data;
};

export const addAssignmentGroupMember = async (groupId, payload) => {
  const response = await api.post(`/assignment-groups/${groupId}/members`, payload);
  return response.data;
};

export const removeAssignmentGroupMember = async (groupId, userId) => {
  const response = await api.delete(`/assignment-groups/${groupId}/members/${userId}`);
  return response.data;
};
